import * as actionTypes from './actionTypes';

export const toggleFinishModal=(collectionId)=>({
    type:actionTypes.TOGGLE_FINISH_MODAL,
    payload:collectionId
})